module.exports = __webpack_public_path__ + "static/img/cca-1.f42e80a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact/cca-1.png
// module id = 960
// module chunks = 0